import React, { PureComponent  } from 'react';
import Wrp from '../../hoc/Wrp/Wrp';
import http from '../../services/http';
import {isSet,getSelectedValueBasedOnField,getSelectedValueFromForm} from '../../Utils/CommonFunctions';
import {placeActionButtons} from '../../Containers/LayoutContainer/LayoutCommonFunction';
import {getUserInfo} from '../../Utils/UserFunctions';
// import {getProfileAuthorities} from '../../Utils/UserFunctions';
import htmlToJson from 'html-to-json';
import $ from 'jquery';
import {
    extractStylesAsObjects,
    getFieldsPropsElement,
    getFieldsPropsSection,
    getOutputFieldsElement,
    extractFieldValue
} from './MarkupFunctions';

class MarkupConversion extends PureComponent  {
    constructor(props) {
        super(props);
        this.state = {
          htmlElement:[],
          childActionButtons:{},
          dynamicAssignVar:{}
        };
        this.hasMounted = {};
        this.functionMap = {
          rotateCard: this.rotateCard.bind(this),
          dynamicVariableMethod: this.dynamicVariableMethod.bind(this)
          // rotateCard:function(btn) {
          //     // Find the closest ancestor with class 'rates-container'
          //     var $card = btn.currentTarget.closest('.rates-container');
          //     // // Check if $card has class 'hover'
          //     if ($card.classList.contains('hover')) {
          //         // Remove 'hover' class if present
          //         $card.classList.remove('hover');
          //     } else {
          //         // Add 'hover' class if not present
          //         $card.classList.add('hover');
          //     }
          // },
          // dynamicVariableMethod:function(key,val){
          //   this.setState({
          //     dynamicAssignVar:{
          //       ...this.state.dynamicAssignVar,
          //       [key]:val
          //     }
          //   })
          // }
        }
    }
    // Method to handle rotating the card
    rotateCard(btn) {
      // Find the closest ancestor with class 'rates-container'
      var $card = btn.currentTarget.closest('.rates-container');
      // Check if $card has class 'hover'
      if ($card.classList.contains('hover')) {
          // Remove 'hover' class if present
          $card.classList.remove('hover');
      } else {
          // Add 'hover' class if not present
          $card.classList.add('hover');
      }
    }

    // Method to dynamically assign variables
    dynamicVariableMethod(key, val) {
      // console.log('key, val',key, val);
      // console.log('dynamicAssignVar',this.state.dynamicAssignVar); 
      this.setState(prevState => ({
          dynamicAssignVar: {
              ...prevState.dynamicAssignVar,
              [key]: val
          }
      }));
    }
    componentDidUpdate = (prevProps)=>{
        if(prevProps.renderProps!==this.props.renderProps){
            this.convertMarkupToJSON(this);
            window.addEventListener("resize", this.updateDimensions);
            this.updateDimensions();
        }
    }
  
  componentDidMount = ()=>{
      const {actionButton} = this.props;
      // console.log(actionButton);
      if(actionButton && isSet(actionButton.window_mapping_id,null)!==null){
        //API CALL FOR MANNUAL WINDONW ACTION BUTTON DETAILS
        this.fetchActionButtonLists(isSet(actionButton.window_mapping_id,null));
      }
        this.convertMarkupToJSON(this);
        window.addEventListener("resize", this.updateDimensions);
        this.updateDimensions();
  }

  fetchActionButtonLists = (windowId)=>{
   
    const queryString = '?query=&page=0&orderBy=&size=1000&direction=';
    const API_Url = "component-actions/list/"+windowId+queryString;
    http.GET(API_Url)
        .then(res => {
          if(res.status===200){ 
            const response = res.data;
            const {match} = this.props;
            const params = match.params;
            if(response.code===200){
              const responseData = response.data.content;
              const actionBtn = placeActionButtons({
                components:responseData,
                params:params
              });
              this.setState({
                childActionButtons:actionBtn
              });
            }
          }
    }).catch(err => {
          console.log(err);
    })
  }
  componentWillUnmount() {
    this.updateDimensions();
    // window.removeEventListener('resize', this.updateDimensions);
  }
  //Toogle listener left-bar while resize
  updateDimensions = ()=>{
    $('#sidebarCollapse').on('click', function () {
      $('#splitView_sidebar').toggleClass('active');
      $('.sidebarOverlay').toggleClass('overlayVisible');
    });
    if ($(window).width() < 992) {
        $('#splitView_sidebar').addClass('active');
    } else {
        $('#splitView_sidebar').removeClass('active');
    }
  }

    render() {

      const {htmlElement} = this.state;
        return this.convertAndCreateElement(htmlElement,{loopData:[],dynamicVar:{}});
    }
    

  // Function to split function name and arguments
  splitFunctionAndArgs = (value)=> {
    const index = value.indexOf('(');
    if (index !== -1) {
      const functionName = value.slice(0, index).trim();
      const args = value.slice(index + 1, -1).trim();
      return [functionName, args];
    } else {
      return [value.trim(), null];
    }
  }
   convertToReactEvent = (attributes)=> {
    const eventHandlerMapping = {
      onclick: 'onClick',
      onmouseover: 'onMouseOver',
      onmouseout: 'onMouseOut',
      onmousedown: 'onMouseDown',
      onmouseup: 'onMouseUp',
      onmousemove: 'onMouseMove',
      onkeydown: 'onKeyDown',
      onkeypress: 'onKeyPress',
      onkeyup: 'onKeyUp',
      onfocus: 'onFocus',
      onblur: 'onBlur',
      onchange: 'onChange',
      onsubmit: 'onSubmit',
      onreset: 'onReset',
      oninput: 'onInput',
      oncontextmenu: 'onContextMenu',
      onwheel: 'onWheel',
      // Add other event handlers as needed 
    };
  
    const reactAttributes = {};
  
    for (let [key, value] of Object.entries(attributes)) {
      if (eventHandlerMapping[key]) {
        const [functionName, args] = this.splitFunctionAndArgs(value);
        if (functionName && this.functionMap[functionName]) {
          if (args) {
            if (value.includes('this')) {
              reactAttributes[eventHandlerMapping[key]] = (e) => this.functionMap[functionName](e);
            } else {
             
              const splitArgs = args.includes(',') ? args.split(',') : [args];
              const cleanedArgs = splitArgs.map(arg => arg.replace(/'/g, ''));
              reactAttributes[eventHandlerMapping[key]] = () => this.functionMap[functionName](...cleanedArgs);
              // console.log('args',cleanedArgs);
            }

           
          } else {
            reactAttributes[eventHandlerMapping[key]] = this.functionMap[functionName];
          }
        } else {
          console.warn(`Function '${functionName}' not found in this.functionMap.`);
        }
      } else {
        reactAttributes[key] = value;
      }
    }
  
    return reactAttributes;
  }
  // Function to convert event names to React format
  convertEventNameToReact = (eventName) => {
    // Check if the event name starts with "on" and has at least one more character
    if (eventName.startsWith('on') && eventName.length > 2) {
      // Convert the first character after "on" to uppercase and concatenate with the rest
      return 'on' + eventName.charAt(2).toUpperCase() + eventName.slice(3);
    }
    // If the event name doesn't start with "on", return it as is
    return eventName;
  };

   isValidJson = (value) => {
    if (typeof value === "object" && value !== null && !Array.isArray(value)) {
      try {
        JSON.stringify(value);
        return true;
      } catch (e) {
        return false;
      }
    }
    return false;
  };
   buildElementString = (node) => {
    if (node.type === 'text') {
        // Return text nodes directly
        return node.data || '';
    }

    if (node.type === 'tag') {
        // Start the tag
        const attributes = Object.entries(node.attribs || {})
            .map(([key, value]) => `${key}="${value}"`)
            .join(' ');

        // Build children recursively
        const children = (node.children || [])
            .map(this.buildElementString)
            .join('');

        return `<${node.name}${attributes ? ` ${attributes}` : ''}>${children}</${node.name}>`;
    }

    return '';
};


    convertAndCreateElement = (htmlElement,paramObj)=>{
      const {childActionButtons} = this.state;
      const {loopData,dynamicVar,dataTable} = paramObj;
        let notAllowingTagReplacement = {'html':'manualhtml','meta':'manualheta','title':'manualtitle','script1':'manualscript'};
        let notAllowingTag = ['html','meta','title','script1'];
      //  console.log('this.props',this.props);
        return htmlElement.map((item,itemIndex)=>{
            const {children,type} = item;
            const attribs = (item.hasOwnProperty('attribs')===true)?item.attribs:{};
            let tagName   = (item.hasOwnProperty('name')===true)?item.name:'';
            const defParams = {tagName:tagName,loopData:loopData,defProps:this.props,dataTable:dataTable,dynamicVar:dynamicVar,children:children,childActionButtons:childActionButtons};
            
           
          
            let attributes ={
              ...this.convertToReactEvent(attribs),
              id:isSet(attribs.id,itemIndex),
            }
           
            let attribsName = (attributes.hasOwnProperty('name')===true)?attributes.name:'';
            if(attributes.hasOwnProperty('style') && typeof attributes.style==='string'){
              attributes.style = extractStylesAsObjects(attributes.style);
            }
           

            if(notAllowingTag.indexOf(tagName)!==-1){
              tagName = notAllowingTagReplacement[tagName];
            }
            if ($(window).width() < 768) {
                $('#splitView_sidebar').addClass('active');
            } else {
                $('#splitView_sidebar').removeClass('active');
            }
       
        // console.log('attributes',attributes);
        for (let key in attributes) {
          // console.log('attributes loggeda',this.hasMounted);

         
          if((key==='class' || key==='classname' || key==='title' || key==='id' || key==='href')){
            const attrbsElmt = attributes[key].toString();
            let  attrDisplayContent = attrbsElmt;
            
            if((key==='class' || key==='classname') && Object.hasOwn(attributes, 'data-onload-class')===true){
              // console.log('isObject',attrDisplayContent,Object.hasOwn(attributes, 'data-onload-class'));
              let element = document.getElementById(attributes.id);
              if(element){
                attributes = {
                  ...attributes,
                  [key]:isSet(element.getAttribute('class'),'')
                }
                // continue;
              }
            }
           
            if(isSet(attrDisplayContent,null)!==null && attrDisplayContent.indexOf('${') !== -1 && attrDisplayContent.indexOf('}') !== -1){
              const paramsPattern = /[^${\}]+(?=})/g;
              let extractParams = attrbsElmt.match(paramsPattern);
              isSet(extractParams,[]).forEach((expFiedName)=>{
                let replacingValue = getOutputFieldsElement({...attributes,value:expFiedName.trim()},defParams);
                replacingValue     = (replacingValue==='-')?'':replacingValue;
                
                if(key==='class' || key==='classname'){
                  attrDisplayContent = attrDisplayContent.replace('${'+expFiedName+'}',`"${replacingValue}"`);
                }else{
                  attrDisplayContent = attrDisplayContent.replace('${'+expFiedName+'}',`${replacingValue}`);
                }
                

                const ternaryRegex = /\(.*?\)\s*\?\s*.*?\s*:\s*.*/;
                
                 if(ternaryRegex.test(attrDisplayContent)===true){
                  try{
                    attrDisplayContent = eval(attrDisplayContent);
                  }catch(e){
  
                  }
                 }
                //  console.log('attrDisplayContent',attrDisplayContent);
                attributes = {
                  ...attributes,
                  [key]:attrDisplayContent
                }
              });
                  
               }
           
            }
        }
     
      try{
        if(item.parent.type==='script'){
          const itemData = item.data;
          let  displayContent = itemData;
          const parser = new DOMParser();
          const doc = parser.parseFromString(displayContent, 'text/html');
          displayContent = eval(doc.documentElement.textContent);
        }
       
      }catch(e){

      }
      try{
        if(tagName==='svg'){
          const renderitm = this.buildElementString(item);
          return <span dangerouslySetInnerHTML={{ __html: renderitm }} />
        }
      }catch(e){

      }
      
        if(type==='tag' || type==='style'){
            switch (tagName) {
                case "scm:inputtext":
                    return  getFieldsPropsElement(attributes,{type:'FIELD',...defParams});
                case "scm:inputsection":
                    return getFieldsPropsSection(attributes,{type:'SECTION',...defParams});
                // case "scm:inputsubform":
                //     return getFieldsPropsElement(attributes,{type:'SECTION',defProps:this.props});
                case "scm:outputtext":
                case "scm:outputimage":
                    const dataElmt = getOutputFieldsElement(attributes,defParams);
                    const dataElmtStr = this.isValidJson(dataElmt) ? JSON.stringify(dataElmt) : dataElmt;
                    return React.createElement(Wrp, {...attributes},this.convertAndCreateElement([{data:dataElmtStr,type:'text'},...isSet(children,[])],{loopData,dataTable,dynamicVar,childActionButtons}));
               case "scm:decision":
                case "scm:if":
                    return this.getConditionalFieldsElement(attributes,defParams);
                case "scm:datatable":
                    return this.getDataTableDetails(attributes,defParams);
                case "scm:button":
                    return this.getActionButtonsElement(attributes,defParams,children,{loopData,dataTable,dynamicVar,childActionButtons});
                default:
                    if(children.length===0){
                        return React.createElement(tagName, {...attributes});
                    }else{
                        return React.createElement(tagName, {...attributes}, this.convertAndCreateElement(children,{loopData,dataTable,dynamicVar,childActionButtons}));
                    }
            }
        }else if(type==='text'){
            const itemData = item.data;
            let  displayContent = itemData;
            if (typeof itemData === 'string') {
              // console.log('itemData',itemData);
              const startingIndex = itemData.indexOf('${');
              const endingIndex = itemData.indexOf('}');
              if (itemData.indexOf('${') !== -1 && itemData.indexOf('}') !== -1){
                  let variableValue = itemData.substring((startingIndex), endingIndex);
                  variableValue = variableValue.replace(/{/gi,'');
                  variableValue = variableValue.replace('$','');
                  variableValue = variableValue.replace(/}/gi,'');
                  const replacingValue = getOutputFieldsElement({...attributes,value:variableValue.trim()},defParams);
                  displayContent = itemData.replace('${'+variableValue+'}',replacingValue);
              }
            }
            return displayContent;
        }else if(type==='script'){
          if(children.length===0){
            return React.createElement(tagName, {...attributes});
          }else{
              return React.createElement(tagName, {...attributes}, this.convertAndCreateElement(children,{loopData,dataTable,dynamicVar,childActionButtons}));
          }
        }
      })
      
    }

    //CONVERT HTML TEMPLATE TO JSON AND SET AS STATE
    convertMarkupToJSON =(wthis)=>{
        let dynamicContent = '<Root>'+this.props.htmlContent+'</Root>';
        var promise = htmlToJson.parse(dynamicContent, {
            'HTML': function ($doc) {
            return $doc;
            }
        },function (err, result) {
                // result.HTML[0].children.map((item)=>{
                //     console.log(item.children);
                //     let htmlElement = item.children;
                //     htmlElement.push({...htmlElement});
                // });
        });
        promise.done(function (result) {
            result.HTML[0].children.map((item)=>{
                // console.log(item.children);
                wthis.setState({htmlElement:item.children});
            })
        });
    }
  getActionButtonsElement = (attributes,paramObj,children,childParams)=>{
    // console.log('attributes',attributes,childActionButtons);
    const {loopData,defProps} = paramObj;
    const {name,label,type,fields} = attributes;
    const {actionButtons} = defProps;
    // console.log('paramObj',attributes,name);
    const {isExist,isCustom,data} = this.findActionButtons(this.state.childActionButtons,actionButtons,name);
    // console.log('isExist',isExist,isCustom,name,data,actionButtons);
    if(isExist===true && name.toLowerCase()=='ship now'){
      return React.createElement('a', {...attributes,onClick:()=>this.props.onSubmitShipNow({},false,{selected_rate:loopData,btnOption:data})},isSet(label,name));  
    }else if(isExist===true && isCustom===true && isSet(data.clickHandler,null)!==null){
      return React.createElement('a', {...attributes,onClick:data.clickHandler},name); 
    }else if(isExist===true){
       return React.createElement('a', {...attributes,onClick:()=>this.props.dynamicSystemHandler({},false,{selected_rate:loopData,btnOption:data})},isSet(label,name));   
    } else{
      let clickHandlerMethod = ()=>{};
      if(type==="clear"){
        clickHandlerMethod = ()=>this.clearButtonHandlers(fields,defProps)
      }
      if(children.length===0){
        return React.createElement('a', {...attributes,onClick:clickHandlerMethod},isSet(label,name));
      }else{
        return React.createElement('a', {...attributes,onClick:clickHandlerMethod}, this.convertAndCreateElement(children,childParams));
      }
    }           
  }
  clearButtonHandlers = (fields,defProps)=>{
    const fieldsInSplits = fields.split(',');
    const {fieldGroups} = defProps;
    let assignValuesInArray = [];
    let fieldsInArr = [];
    isSet(fieldsInSplits,[]).forEach((variableValue)=>{
      let fieldName = variableValue.replace(/{/gi,'');
      fieldName = fieldName.replace('$','');
      fieldName = fieldName.replace(/}/gi,'');
      fieldsInArr.push(fieldName.toLowerCase());
    });
    
    fieldGroups.forEach((section,sectionIndex) => {
      if(section.type!=='subform'){
          section.data.forEach((field,fieldIndex)=>{
              if(fieldsInArr.indexOf(field.label.blocks[0].text.toLowerCase())!==-1){ 
                const obj = {
                  key:{type:'SECTION',section:section,sectionIndex:sectionIndex,fieldIndex:fieldIndex,modType:this.props.modType},
                  value:''
                }
                assignValuesInArray.push(obj);
              }
          }) 
      }
    });
    this.props.onBlurAfterChange({valuesInArr:assignValuesInArray,modType:this.props.modType,isBulk:true},'');
  }
  findActionButtons = (obj,otherActions=[],buttonName)=>{
    let returnData = {isExist:false,data:{}};
    Object.entries(obj).map(([key,val])=>{
      val.map((item)=>{
        if(item.name.toLowerCase()===buttonName.toLowerCase()){
          returnData = {
            isExist:true,
            data:item
          }
        }
      })
    });
    // console.log('otherActions',otherActions,buttonName); 
    const indexing = isSet(otherActions,[]).findIndex((i=>isSet(i.name,isSet(i.component_name,'')).toLowerCase()===isSet(buttonName,'').toLowerCase()));
    // console.log('indexingindexing',indexing,otherActions);
    
    if(indexing!==-1){
      returnData = {
        isExist:true,
        isCustom:true,
        data:{
          data:isSet(otherActions[indexing]['action_component'],{}),
          ...otherActions[indexing],
        }
      }
    }
    return returnData;
  }

  dynamicSystemHandler = ({selected_rate,btnOption})=>{
  }
   flattenPathObject = (map, pathString) =>{
    const path = pathString.split('.');
    let pathMap =['item'];
     path.forEach((i)=>{
      pathMap.push("['"+i+"']");
    })
    let flatmap = [];
      flatmap = isSet(map,[]).flatMap(item => {
        try{
          return isSet(eval(pathMap.join('')),[]); // Use eval to access the dynamic path
        }catch(e){
          return [];
        }
      });
    return flatmap;
  }
   sortByKey = (data, key, order) => {
    // console.log('data, key, order',data, key, order);
    return data.sort((a, b) => {
      const aValue = this.getNestedValue(a, key);
      const bValue = this.getNestedValue(b, key);
      if (order.toLowerCase() === 'asc') {
        return aValue > bValue ? 1 : -1;
      } else {
        return aValue < bValue ? -1 : 1; // Corrected descending order logic
      }
    });
  };

  // Function to access nested object properties using a string path
   getNestedValue = (obj, path) => {
    return path.split('.').reduce((acc, part) => acc && acc[part], obj);
  };
  // sortByDataList = (array, sort,order = 'asc') => {
  //   return array.sort((a, b) => {
  //     if (order.toLowerCase() === 'asc') {
  //       return a.final_rate - (b[sort]);
  //     } else if (order.toLowerCase() === 'desc') {
  //       return b.final_rate - (a[sort]);
  //     } else {
  //       // throw new Error("Order must be either 'asc' or 'desc'");
  //     }
  //   });
  // };

   sortByDataList = (array, sort, order = 'asc') => {
    const keys = sort.split(',').map(k => k.trim());
  
    return array.sort((a, b) => {
      for (const key of keys) {
        const aVal = a[key];
        const bVal = b[key];
  
        if (aVal !== bVal) {
          if (order.toLowerCase() === 'asc') {
            return aVal - bVal;
          } else if (order.toLowerCase() === 'desc') {
            return bVal - aVal;
          }
        }
      }
      return 0; // All keys equal
    });
  };
 
  getDataTableDetails = (attributes,paramObj)=>{
    const {children} = paramObj;
    const {dynamicAssignVar} = this.state;
    let {dynamicVar,tagName} = paramObj;
    const {fieldGroups,nonFieldGroups,subform_data,rateWithShipments,outputResponse} = this.props;
    let fieldAndNonFieldGroups = [...fieldGroups,...isSet(nonFieldGroups,[])];
    let {entries,flatmap,sort,sortby} = attributes;
   
    if(isSet(entries,null)===null){ return false;}
    
    let element = null;
    let iterateArrayObject = [];
    dynamicVar = {
      ...dynamicVar,
      ...outputResponse
    }
    try{
      if(entries.indexOf('.keys()')!==-1){
        const replaceEntries = entries.replace('.keys()','');
        const objectKeys = Object.keys(dynamicVar[replaceEntries]);
        iterateArrayObject = objectKeys;
        // console.log('iterateArrayObject',iterateArrayObject);
      }else{
        // let str = entries;
        // Object.entries(dynamicVar).map(([key, value]) => {
        //   str = str.replace(key,'dynamicVar["'+key+'"]');
        // })
        dynamicVar = {
          ...dynamicVar,
          [entries]:rateWithShipments[entries]
          
        }
          // console.log('constVar '+ str,dynamicVar);
        try{
            dynamicVar = {
              ...dynamicVar,
              [entries]:extractFieldValue(dynamicVar,entries)
              
            }
            // console.log('eval...',entries,e229val(str));
        }catch(e){
            // console.log(e);
        }
        if(isSet(flatmap,null)!==null){
          dynamicVar = {
            ...dynamicVar,
            [entries]:this.flattenPathObject(dynamicVar[entries],flatmap)
          }
          //  
          
        }
       
        iterateArrayObject = dynamicVar[entries];
        // console.log('dynamicVar',dynamicVar,entries,iterateArrayObject);
        if(isSet(sort,null)!==null){
          const sorted = this.sortByDataList([...iterateArrayObject],sort, isSet(dynamicAssignVar[attributes.var],sortby)); 
          iterateArrayObject = sorted;
        }
        // console.log('iterateArrayObject',iterateArrayObject);
        // console.log('dynamicVar',dynamicVar,entries);

      }
    }catch(e){
      // console.log('e',e);
    }
    try{
        fieldAndNonFieldGroups.map((section)=>{
          if(section.type==='subform'){
            let lookupDataArr = [];
            // console.log('isSet.toLowerCase',isSet(entries,'').toLowerCase());
            if(section.title.toLowerCase()===isSet(entries,'').toLowerCase()){
              subform_data.map((subSec)=>{
                if(subSec.field_group_section_id===section.id){
                  subSec.subform_rows.map((subRows)=>{
                    let fieldRow = {};
                    subRows.subform_column_values.map((subCol)=>{
                     
                      const finding = section.data.find((i=>i.id===subCol.table_descriptor_id));
                      const selectedValue = getSelectedValueBasedOnField({...finding,selectedValue:subCol.selected_value})
                      fieldRow  = {
                        ...fieldRow,
                        [isSet(subCol.display_name,'')]:(selectedValue!=='-None-')?selectedValue:''
                      }
                    })
                    lookupDataArr.push(fieldRow);
                  })
                  
                }
              })
              iterateArrayObject = lookupDataArr;
            }
          }else{
            return section.data.map((field)=>{
            if(field.label.entityMap==null){
                field.label.entityMap = {};
              }
              let selectedValue = null;
              let elementType = field.element;
              // let isDetailView = field.is_present_in_detailview;
              let selectedValueJSON = null;
              let lookupDataArr = [];
              // console.log('fieldd',field);
              //isSet(field.value,'').toLowerCase()===isSet(type,'').toLowerCase() ||
              if( field.label.blocks[0].text.toLowerCase()===isSet(entries,'').toLowerCase()){
              if((elementType==='MultiLookup' || elementType==='Lookup')){
                  try { 
                    selectedValueJSON = (field.selectedValue!=='')?JSON.parse(field.selectedValue):'';
                  }catch(e){

                  }
                  if(elementType==='Lookup' || (Array.isArray(selectedValueJSON)===false) || selectedValueJSON===null || selectedValueJSON===''){
                      if(section.refLookup===true){
                      selectedValue = selectedValueJSON;
                      
                      }else{
                      selectedValue = [];
                      selectedValue.push(selectedValueJSON);
                      } 
                    }else{
                        selectedValue = selectedValueJSON;
                    }
                    isSet(field.stateValue,[]).map((contentData)=>{
                      let fieldRow = {};
                      Object.entries(contentData.data.data).map(([key, val]) => {
                        if(isSet(val.label,'')!==''){
                          fieldRow  = {
                            ...fieldRow,
                            [isSet(val.label,'')]:val.value
                          }
                        }
                      })
                      lookupDataArr.push(fieldRow);
                    });
                    isSet(selectedValue,[]).map((contentData)=>{
                        let fieldRow = {};
                        try{
                          if(elementType==='Lookup'){
                            // console.log('contentData',contentData);
                            fieldRow  = {
                              ...fieldRow,
                              [contentData.id]:contentData.dpnm
                            }
                          }
                        }catch(e){

                        }
                      if(contentData!==null && contentData!==''){
                        contentData.fieldGroups.map((section)=>{
                          section.data.forEach((item)=>{
                              try{
                                fieldRow  = {
                                  ...fieldRow,
                                  [item.label.blocks[0].text]:getSelectedValueBasedOnField(item)
                                }
                              }catch(e){

                              }
                              
                            return item;      
                          })
                          return section;   
                        });
                      }
                      if(Object.entries(fieldRow).length>0){
                        lookupDataArr.push(fieldRow);
                      }
                      return contentData;
                    });
              }
              iterateArrayObject = lookupDataArr;
              // console.log('iterateArrayObject',iterateArrayObject);
              }
              })
          }
      })
    }catch(e){
      console.log('e',e);
    }
    
    
    try{
      element = iterateArrayObject.map((loopData,index)=>{
        // console.log('loopData',loopData,children);
        dynamicVar = {
          ...dynamicVar,
          [attributes.var]:{
            ...loopData,
            loopIndex:index
          }
        }
        if(children.length===0){
          return React.createElement(tagName, {...attributes});
        }else{
            if(tagName==='scm:datatable'){
              tagName = isSet(attributes.tag,tagName);
              return this.convertAndCreateElement(children,{...paramObj,loopData:{
                ...loopData,
                loopIndex:index
              },dynamicVar:dynamicVar});
            }
            // console.log('tagName',tagName);
          return React.createElement(tagName, {...attributes}, this.convertAndCreateElement(children,{...paramObj,loopData:{
            ...loopData,
            loopIndex:index
          },dynamicVar:dynamicVar}));
        }
      });
      
    }catch(e){
      dynamicVar = {
        ...dynamicVar,
        [attributes.var]:iterateArrayObject
      }
      
      if(children.length===0){
        return React.createElement(tagName, {...attributes});
      }else{
          if(tagName==='scm:datatable'){
            tagName = isSet(attributes.tag,tagName);
            return this.convertAndCreateElement(children,{...paramObj,dynamicVar:dynamicVar});
          }
        return React.createElement(tagName, {...attributes}, this.convertAndCreateElement(children,{...paramObj,dynamicVar:dynamicVar}));
      }
    }
    return element;
  }

  isContains = (arr,value)=>{
    // console.log('arr',arr,value,arr.indexOf(value));
    if(arr.indexOf(value)!==-1){
      return true
    }else{
      return false;
    }
  }

  getConditionalFieldsElement = (attributes,paramObj)=>{
    let tagName = Wrp;
    let decisionResult    = [];
    const decisionObj     = this.getDecisionMaking(attributes,paramObj);
    // console.log('decisionObj',decisionObj);
    let updateAttributes  = attributes;
    if(isSet(decisionObj['elseif'],{result:false}).result===true){
      updateAttributes    = isSet(decisionObj['elseif'],{attributes:{}}).attributes;
      decisionResult      = isSet(decisionObj['elseif'],{children:[]}).children;
    }else{
      updateAttributes    = isSet(decisionObj['else'],{attributes:{}}).attributes;
      decisionResult      = isSet(decisionObj['else'],{children:[]}).children;
    }
    if(decisionResult.length===0){
      return false;
    }else{
      return React.createElement(tagName, {...updateAttributes}, this.convertAndCreateElement(decisionResult,paramObj));
    }
}
decisionMakingCondition = (attributes,paramObj,returnDecision)=>{
  const {tagName,defProps,children,dynamicVar} = paramObj;
  const {fieldGroups,formFields} = defProps;
  // let returnDecision ={};
  // console.log('attributes',attributes,tagName);
  if(tagName==='scm:if' || tagName==='scm:elseif'){
    if(attributes.condition===undefined){return false;}
    const condition = attributes.condition;
    const paramsPattern = /[^${\}]+(?=})/g;
    // console.log('condition',condition);
    let extractParams = condition.match(paramsPattern);
    let formulaExpExe = condition;
    let formulaValue = {
      selectedValue:''
    }
    // console.log('isSet(extractParams,[])',isSet(extractParams,[]));
    isSet(extractParams,[]).map((expFiedName)=>{
      const exactFieldName = expFiedName;//.replace(windowName+'.','');
      // console.log('dynamicVar11',dynamicVar,expFiedName);
      if(isSet(extractFieldValue(dynamicVar,expFiedName),null)!==null){
        formulaValue = {
              selectedValue:isSet(extractFieldValue(dynamicVar,expFiedName),null)
            }
      }else if(exactFieldName==='scm_loggedin_user_role'){
        try{
          const userInfo = getUserInfo();
          const userInfoData = userInfo.data;
          const selectedValue = userInfoData.role_name;
          // console.log(" ",userInfoData);
          formulaValue = {
            selectedValue:selectedValue
          }
        }catch(e){
          console.log('e',e);
        }
      }else if(exactFieldName==='scm_loggedin_user_profile'){
          const userInfo = getUserInfo();
          try{
            const userInfoData = userInfo.data;
            const selectedValue = userInfoData.profile_name;
            formulaValue = {
              selectedValue:selectedValue
            }
          }catch(e){
    
          }
      }else{
        
        const valueGrp = getSelectedValueFromForm({fieldGroups:fieldGroups,subformData:[],mappingTags:[]},{searchBy:'name',fieldData:{},fieldName:exactFieldName},false);
        formulaValue={
          ...valueGrp,
          selectedDisplayValue:getSelectedValueBasedOnField(isSet(valueGrp.field,{}),'',true)
        }
        const indexing = isSet(formFields,[]).findIndex((i=>i.label.toLowerCase()===exactFieldName.toLowerCase()));
        // console.log('indexingindexing',indexing,formFields);
        if(indexing!==-1){
          formulaValue={
            ...valueGrp,
            selectedDisplayValue:isSet(formFields,[])[indexing].value
          }
        }
      }
      
      try{
        formulaExpExe = formulaExpExe.replace('${'+isSet(expFiedName,null)+'}',"'"+isSet(formulaValue.selectedDisplayValue,isSet(formulaValue.selectedValue,null))+"'");
        // console.log('dynamicVar11 formulaExpExe1',condition,eval(formulaExpExe),formulaExpExe);
        if(eval(formulaExpExe)===true){
          returnDecision={
            ...returnDecision,
            elseif:{
              result:true,
              children:children,
              attributes:attributes
            }
          }
        }
      }catch(e){

      }
     
    })
  }else if(tagName==='scm:else'){
    // console.log('formulaValue',attributes,children);
    returnDecision={
      ...returnDecision,
      else:{
        result:true,
        children:children,
        attributes:attributes
      }
    }
  }
  return returnDecision;
}
getDecisionMaking = (attributes,paramObj)=>{
  const {children} = paramObj;
  const {rateWithShipments,outputResponse} = this.props;
  // console.log('paramObj',paramObj);
  let dynamicVar = paramObj.dynamicVar;
  dynamicVar = {
    ...dynamicVar,
    ...outputResponse
  }
  let {entries,flatmap} = attributes;
  if(isSet(entries,null)!==null){
    dynamicVar = {
      ...dynamicVar,
      [entries]:isSet(rateWithShipments[entries],null)
    }
    if(isSet(flatmap,null)!==null){
      dynamicVar = {
        ...dynamicVar,
        [attributes.var]:this.flattenPathObject(dynamicVar[entries],flatmap)
      }
    }
  }

  let returnDecision = this.decisionMakingCondition(attributes,{...paramObj,dynamicVar:dynamicVar},{});
  if(isSet(returnDecision['elseif'],{result:false}).result===true){
    return returnDecision;
  }
  
  // console.log('dynamicVar',dynamicVar);
  children.map((item,itemIndex)=>{
      const attribs = (item.hasOwnProperty('attribs')===true)?item.attribs:{};
      let childAttributes ={
        ...attribs,
        id:isSet(attribs.id,itemIndex)
      }
      let tagName = (item.hasOwnProperty('name')===true)?item.name:'';
      // const children = item.children;
      if(childAttributes.hasOwnProperty('style') && typeof childAttributes.style==='string'){
        childAttributes.style = extractStylesAsObjects(childAttributes.style);
      }
      returnDecision = this.decisionMakingCondition(childAttributes,{...paramObj,dynamicVar:dynamicVar,children:item.children,tagName:tagName},returnDecision);
    })
    return returnDecision;
  }
}

MarkupConversion.defaultProps = {
  layoutObject:{},
  subform_data:[],
  nonFieldGroups:[],
  fieldGroups:[],
  formFields:[],
  validationForms:[],
  onChangeInputAction:()=>{},
  onBlurHandlerAction:()=>{},
  renderProps:[],
  actionButtons:[],
  modType:'',
  DVauditLog:{},
  htmlContent:'',
  layoutForms:true,
  formsPayload:{}
}

export default MarkupConversion;